{
    "EU": {
        "length": "m",
        "width_thickness": "mm",
        "crown_wedge": "μm",
        "weight": "t",
        "rp": "MPa",
        "rm": "MPa",
        "reH": "MPa",
        "reL": "MPa"
    },
    "US": {
        "length": "ft",
        "width_thickness": "in",
        "crown_wedge": "μin",
        "weight": "US t",
        "rp": "psi",
        "rm": "psi",
        "reH": "psi",
        "reL": "psi"
    }
}